module.exports = "https://coursera_assets.s3.amazonaws.com/images/653449eb209c5cc24d2935ed5a0f18cd.png";